'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { ReactNode, Suspense, use, useEffect } from 'react'
import { gtm, segment } from '@/utils/tracking.utils'
import { MWCookies } from '@/app/_actions/get-cookies.action'

export const getSource = (hasMobileAppCookie: boolean): string => (
  hasMobileAppCookie ? 'mobile-app' : 'web'
)

type Props = {
  mwCookiesPromise: Promise<MWCookies>
}

const AnalyticsCore = ({ mwCookiesPromise }: Props): null => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const mwCookies = use(mwCookiesPromise)

  useEffect(() => {
    const search = searchParams.toString() ? `?${searchParams.toString()}` : ''
    const url = `${window.location.origin}${pathname}${search}`
    const source = getSource(mwCookies.isMobileAppView)

    segment.page({
      referrer: document.referrer,
      url,
      search,
      path: pathname,
      source,
    })

    gtm.track({
      event: 'pageview',
      url,
      source,
    })
  }, [pathname, searchParams, mwCookies.isMobileAppView])

  return null
}

const TrackPageViews = (props: Props): ReactNode => {
  return (
    <Suspense fallback={null}>
      <AnalyticsCore {...props} />
    </Suspense>
  )
}

export default TrackPageViews
